export default __webpack_public_path__ + "static/media/section3_bg2.74b729c5.svg";